<template>
  <b-form-input
    v-on="$listeners"
    :id="id"
    :ref="refInput"
    type="text"
    :disabled="disabled"
    :autofocus="autofocus"
    :placeholder="placeholder"
    :enableTrimValue="enableTrimValue"
    v-model="_dataModel"
    @input="onInput"
    :class="[
      state ? 'border-danger bg-danger-outline' : '',
      classCustom ? classCustom : ''
    ]"
    :title="title"
    @keydown="onkeydown"
    @paste="onPaste"
    @blur="onBlur"
  />
</template>

<script>
export default {
  model: {
    prop: 'dataModel',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    dataModel: {
      type: Number | String,
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: Number | String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    classCustom: {
      type: Array | String | Object,
      default: null
    },
    refInput: {
      type: String,
      default: ''
    },
    enableTrimValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _dataModel: {
      get() {
        return this.dataModel
      },
      set(value) {
        this.$emit('change', value)
      }
    }
  },
  methods: {
    /**
     * onInputイベント時に、入力値が最大長を超えた場合、カスタムエラーメッセージを設定し、最大長に切り詰めた値をデータモデルに保存します。
     *
     * @param {string} value - 入力された値
     */
    onInput(value) {
      const input = document.getElementById(this.id)
      if (value.length > this.maxlength) {
        input.setCustomValidity(`${this.maxlength}文字以下にしてください。`)
        setTimeout(() => {
          this._dataModel = value.substring(0, this.maxlength)
        }, 10)
      } else {
        input.setCustomValidity('')
      }
      input.reportValidity()
      this.$emit('onInput', value.substring(0, this.maxlength))
    },
    /**
     * onKeydownイベント時に、Enterキーが押された場合、必要であれば入力値の前後空白を削除し、`onKeydown`イベントを発火します。
     *
     * @param {KeyboardEvent} event - 発生したkeydownイベント
     */
    onkeydown(event) {
      if (this.enableTrimValue && event.key === 'Enter') {
        const trimmedValue = this.trimInputAndShowWarningMsg(event.target)
        this._dataModel = trimmedValue
      }
      this.$emit('onKeydown', event)
    },
    /**
     * onPasteイベント時に、`onPaste`イベントを発火します。
     *
     * @param {Event} event - 発生したpasteイベント
     */
    onPaste(event) {
      this.$emit('onPaste', event)
    },
    /**
     * onBlurイベント時に、必要であれば入力値の前後空白を削除し、`onBlur`イベントを発火します。
     *
     * @param {Event} event - 発生したblurイベント
     */
    onBlur(event) {
      if (this.enableTrimValue) {
        const trimmedValue = this.trimInputAndShowWarningMsg(event.target)
        this._dataModel = trimmedValue
      }
      this.$emit('onBlur')
    },
    /**
     * 入力値の前後にある空白を削除し、必要に応じて警告メッセージを表示します。
     *
     * @param {HTMLInputElement} input - チェック対象の入力要素
     * @returns {string} - 空白が削除された後の入力値
     */
    trimInputAndShowWarningMsg(input) {
      const trimmedValue = input.value.trim()
      if (input.value !== trimmedValue) {
        input.setCustomValidity('前後に空白を入れることはできません。前後の空白を削除しました。')
        input.value = trimmedValue
        input.reportValidity()
      } else {
        input.setCustomValidity('')
      }
      return trimmedValue
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/custom-components/InputTextComponent.vue